<script lang="ts" setup>
import nameLogo from '~/assets/icons/logo/name.svg?url';
import bannerImage from '~/assets/images/social.jpg';

const { t } = useI18n();
</script>

<template>
  <div class="socialResponsibilityPage">
    <section class="socialResponsibilityPage__banner">
      <picture>
        <source :srcset="bannerImage" media="(max-width: 767px)" />
        <img :src="bannerImage" :alt="t('description')" class="socialResponsibilityPage__image" />
      </picture>
      <NuxtLink to="/">
        <img :src="nameLogo" alt="Don't Touch My Skin" class="socialResponsibilityPage__logo" />
      </NuxtLink>
    </section>
    <LazyIdleBlogPageLayout hydrate-on-idle path="social-responsibility" :logo="false" />
  </div>
</template>

<i18n>
ru:
  description: Социальная ответственность
en:
  description: Subscription for regular refill delivery
</i18n>

<style lang="scss">
.socialResponsibilityPage {
  &__image {
    height: 80vh;
    width: 100%;
    object-fit: cover;
    display: block;
  }

  &__logo {
    position: absolute;
    top: 30px;
    left: 21px;

    @include mq('sm') {
      width: 121px;
      height: 126px;
    }
  }

  &__banner {
    @include mq('sm') {
      padding: 20px 16px;
      margin-bottom: 20px;
    }

    :deep(.baseBannerCard) {
      width: 100%;
    }
  }
}
</style>
